<template>

    <ul class="card1">
        <li>{{ time }}</li>
        <li>{{ name }}</li>
        <li>{{ studio }}</li>
        <li>{{ location }}</li>
    </ul>

</template>
  
<script setup lang="ts">

defineProps<{
  id: number
  time: string
  name: string
  studio?: string
  location?: string
}>()

</script>
    
<style>

.card1 {
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 10px;   
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  text-align: left;
  padding:5px;
  background: linear-gradient(135deg,  #e2f8d2, #b0d496);
  box-shadow: 3px 3px 5px lightgray;
  list-style-type: none;
}

ul > :nth-child(2){
    font-size: 14px;
    font-weight: bold;
    margin-top: 2px;
    margin-bottom: 2px;
}

</style>
